import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router';

import { AuthenticationPageLayout } from '@/app/shell/AuthenticationPageLayout';

export function RootErrorBoundary() {
  const { t } = useTranslation();
  const error = useRouteError();

  console.error('[RootErrorBoundary] Unhandled route error', error);

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error);

  return (
    <AuthenticationPageLayout>
      <div>
        <p role="alert">
          {t('Error_UnexpectedError', {
            defaultValue: 'Something went wrong. Please try reloading the page.',
          })}
        </p>
        {import.meta.env.DEV && detail !== '' && <p className="text-muted small">{detail}</p>}
        <div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            {t('Button_TryAgain', { defaultValue: 'Try again' })}
          </button>
        </div>
      </div>
    </AuthenticationPageLayout>
  );
}
